export default __webpack_public_path__ + "static/media/heart-fill.41ffa23d.svg";